"use client";

import { useEffect, useRef } from "react";
import { useScroll } from "motion/react";
import Hero from "@/components/hero/Hero";
import MarketingSection from "@/components/CTA/MarketingSection";
import FeatureSection from "@/components/features/FeatureSection";
import FooterSection from "@/components/footer/FooterSection";

export default function Home() {
  // Reference for the main container to track scroll progress
  const containerRef = useRef<HTMLDivElement>(null);

  // Track scroll progress for animations
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end start"],
  });

  useEffect(() => {
    // Handle initial page load animations and scroll behavior
    if (typeof window === "undefined") return;

    // Force scroll to top on page load
    window.scrollTo(0, 0);

    // Disable browser's scroll restoration
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }

    // Temporarily lock scroll during initial animation
    document.body.style.overflow = "hidden";

    const timer = setTimeout(() => {
      document.body.style.overflow = "";
    }, 1500); // Duration matches hero animation

    // Cleanup function
    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <main className="relative" ref={containerRef}>
      <Hero scrollYProgress={scrollYProgress} />
      <MarketingSection />
      <FeatureSection />
      <FooterSection />
    </main>
  );
}
